import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '@libs/common-next';
const INLINE_MEDIA_QUERY = `(min-width: ${BREAKPOINTS.lg}px)`;
export function useSearchOverlay(open) {
  const $ = _c(8);
  const controlsRef = useRef(null);
  const formRef = useRef(null);
  const searchRootRef = useRef(null);
  const [portalContainer, setPortalContainer] = useState(null);
  const isInline = useMedia(INLINE_MEDIA_QUERY, false);
  const isFullscreen = !isInline;
  let t0;
  let t1;
  if ($[0] !== isFullscreen || $[1] !== open) {
    t0 = () => {
      if (!isFullscreen || !open) {
        return;
      }
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = previousOverflow;
      };
    };
    t1 = [isFullscreen, open];
    $[0] = isFullscreen;
    $[1] = open;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = element => {
      searchRootRef.current = element;
      setPortalContainer(element?.closest(".header__main-section-sticky") ?? null);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const setSearchRoot = t2;
  let t3;
  if ($[5] !== isFullscreen || $[6] !== portalContainer) {
    t3 = {
      controlsRef,
      formRef,
      isFullscreen,
      portalContainer,
      searchRootRef,
      setSearchRoot
    };
    $[5] = isFullscreen;
    $[6] = portalContainer;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}